<template>
	<basic-container>
		<el-alert v-if="configDataAll.text" :closable="false" :title="configDataAll.text.memo" type="warning"></el-alert>

		<div style="margin-top: 20px; display: flex">
			<el-button style="width: 100px" type="primary" @click="onRefreshGong">选择险种</el-button>
			<el-select v-model="currentInsureTypes" placeholder="请选择险种" style="margin-left: 30px">
				<el-option
					v-for="(item, index) in productOptions"
					:key="index"
					:label="item.label"
					:value="item.value"></el-option>
			</el-select>
		</div>
		<div v-if="currentInsureTypes" class="u-m-t-20">
			<el-card>
				<avue-form v-model="currentOptionData" :option="dataOption"></avue-form>

				<avue-form v-if="isShowChild" v-model="currentOptionChildData" :option="dataOptionChild"></avue-form>

				<div class="u-flex u-row-center">
					<el-button :loading="isLoading" type="primary" @click="onSubmitData">提交</el-button>
					<el-button :loading="isLoading" type="warning" @click="onRefreshData">手动强制刷新</el-button>
				</div>
			</el-card>
		</div>
	</basic-container>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import { mapGetters } from 'vuex'

import {editConfig, getConfig} from '@/api/dist/dict'

export default {
	name: 'allConfig',
	mixins: [],
	components: {},
	props: {},
	data() {
		return {
			isLoading: false,
			configDataAll: {},
			productOptions: [],
			currentInsureTypes: '',
			currentOptionData: {
				allowOffline: false,
				allowHoliday: false,
				minEmpAge: 0,
				maxEmpAge: 0,
				minEmpSize: 1,
				endTime: '',
				startTime: '',
				refusePrompt: '',
				remind: '',
				childConfig: {},
			},
			currentOptionChildData: {},
			dataOption: {
				labelWidth: 120,
				emptyBtn: false,
				submitBtn: false,
				column: [
					{
						label: '对公支付',
						prop: 'allowOffline',
						type: 'switch',
						dicData: [
							{
								label: '关',
								value: false,
							},
							{
								label: '开',
								value: true,
							},
						],
					},
					{
						label: '节假日对公',
						prop: 'allowHoliday',
						type: 'switch',
						dicData: [
							{
								label: '关',
								value: false,
							},
							{
								label: '开',
								value: true,
							},
						],
					},
					{
						label: '最少投保人数',
						prop: 'minEmpSize',
						type: 'number',
					},
					{
						label: '最多投保人数',
						prop: 'maxEmpSize',
						type: 'number',
					},
					{
						label: '最小年龄',
						prop: 'minEmpAge',
						type: 'number',
					},
					{
						label: '最大年龄',
						prop: 'maxEmpAge',
						type: 'number',
					},
					{
						label: '开始时间',
						prop: 'startTime',
						type: 'time',
						format: 'HH:mm',
						valueFormat: 'HH:mm',
					},
					{
						label: '结束时间',
						prop: 'endTime',
						type: 'time',
						format: 'HH:mm',
						valueFormat: 'HH:mm',
					},
					{
						label: '再次提示',
						prop: 'remind',
						type: 'textarea',
						maxRows: 3,
						minRows: 3,
					},
					{
						label: '拒绝提示',
						prop: 'refusePrompt',
						type: 'textarea',
						maxRows: 3,
						minRows: 3,
					},
				],
			},
			dataOptionChild: {
				labelWidth: 120,
				emptyBtn: false,
				submitBtn: false,
				column: [
					{
						label: '区域限制',
						prop: 'areaConfig',
						type: 'select',
						row: true,
						clearable: false,
						dicData: [],
					},
					{
						label: '对公支付',
						prop: 'allowOffline',
						type: 'switch',
						display: false,
						dicData: [
							{
								label: '关',
								value: false,
							},
							{
								label: '开',
								value: true,
							},
						],
					},
					{
						label: '节假日对公',
						prop: 'allowHoliday',
						type: 'switch',
						display: false,
						dicData: [
							{
								label: '关',
								value: false,
							},
							{
								label: '开',
								value: true,
							},
						],
					},
					{
						label: '开始时间',
						prop: 'startTime',
						type: 'time',
						display: false,
						format: 'HH:mm',
						valueFormat: 'HH:mm',
					},
					{
						label: '结束时间',
						prop: 'endTime',
						type: 'time',
						display: false,
						format: 'HH:mm',
						valueFormat: 'HH:mm',
					},
					{
						label: '账户号',
						prop: 'account',
						display: false,
					},
					{
						label: '账户名称',
						prop: 'accountName',
						display: false,
					},
					{
						label: '开户行',
						prop: 'accountOpening',
						row: true,
						span: 24,
						display: false,
					},
					{
						label: '再次提示',
						prop: 'remind',
						type: 'textarea',
						display: false,
						maxRows: 3,
						minRows: 3,
					},
					{
						label: '拒绝提示',
						prop: 'refusePrompt',
						type: 'textarea',
						display: false,
						maxRows: 3,
						minRows: 3,
					},
				],
			},
			offPayChildSelectList: [],
			offPayChildList: [],
			isShowChild: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {
		currentInsureTypes(newVal = '', oldVal = '') {
			if (newVal !== '' && newVal !== oldVal) {
				this.currentOptionData = {}
				this.currentOptionChildData = {}
				let {
					text: {insureMap},
				} = this.configDataAll
				console.log(insureMap[this.currentInsureTypes], '---2')
				let {
					allowOffline = false,
					allowHoliday = false,
					minEmpAge = '',
					maxEmpAge = '',
					minEmpSize,
					maxEmpSize,
					offpayConfig = {},
				} = insureMap[this.currentInsureTypes]
				this.currentOptionData.allowOffline = allowOffline
				this.currentOptionData.allowHoliday = allowHoliday
				this.currentOptionData.minEmpAge = minEmpAge
				this.currentOptionData.maxEmpAge = maxEmpAge
				this.currentOptionData.minEmpSize = minEmpSize
				this.currentOptionData.maxEmpSize = maxEmpSize
				if (!this.validatenull(offpayConfig)) {
					let {startTime, endTime, remind, refusePrompt, childConfig = {}} = offpayConfig
					this.currentOptionData.startTime = startTime
					this.currentOptionData.endTime = endTime
					this.currentOptionData.remind = remind
					this.currentOptionData.refusePrompt = refusePrompt
					//判断是否存在可选择的子数据
					this.isShowChild = !this.validatenull(childConfig)
					let areaConfig = this.findObject(this.dataOptionChild.column, 'areaConfig')
					if (this.isShowChild) {
						//赋值
						this.currentOptionData.childConfig = this.deepClone(childConfig)
						let tempList = []
						for (let childConfigElement in childConfig) {
							tempList.push({label: childConfigElement, value: childConfigElement})
						}
						areaConfig.dicData = tempList
						areaConfig.change = ({column, value = ''}) => {
							//点击select 获取数据
							if (value !== '') {
								this.currentOptionChildData = this.currentOptionData.childConfig[value] || {}
								this.dataOptionChild.column.forEach((itemData, index) => {
									let {display = false} = itemData
									if (index !== 0 && !display) {
										itemData.display = true
									}
								})
							}
						}
					}
				}
				console.log(this.currentOptionData, '--1')
			}
		},
	},
	created() {
		//获取数据
		getConfig('sys:apply:config').then((res) => {
			let {
				data: {code = -1, data},
			} = res || {}
			if (code === 0) {
				if (!this.validatenull(data)) {
					this.configDataAll = data.records[0]
					let {text = ''} = this.configDataAll
					if (text !== '') {
						this.configDataAll.text = JSON.parse(text)
						let {insureMap = {}} = this.configDataAll.text
						//处理 险种
						for (let insureMapKey in insureMap) {
							this.productOptions.push({
								label: insureMap[insureMapKey].memo,
								value: insureMapKey,
							})
						}
					}
					// this.configDataAll.
				}
			}
		})
	},
	mounted() {},
	methods: {
		//选择工种
		onRefreshGong(value) {
			console.log(value)
		},
		onSubmitData() {
			//处理数据
			this.$confirm('请确保数据无误后，再提交！！！', '提示', {
				confirmButtonText: '一定没问题',
				cancelButtonText: '再检查检查',
			})
				.then(() => {
					this.isLoading = true
					let tempConfigDataAll = this.deepClone(this.configDataAll)

					let {
						text: {insureMap},
					} = tempConfigDataAll
					let tempData = insureMap[this.currentInsureTypes]
					let {
						allowOffline,
						allowHoliday,
						minEmpAge,
						maxEmpAge,
						minEmpSize,
						maxEmpSize,
						startTime,
						endTime,
						remind,
						refusePrompt,
						childConfig,
					} = this.currentOptionData

					tempData.allowOffline = allowOffline
					tempData.allowHoliday = allowHoliday
					tempData.minEmpAge = minEmpAge
					tempData.maxEmpAge = maxEmpAge
					tempData.minEmpSize = minEmpSize
					tempData.maxEmpSize = maxEmpSize
					//判断是否为空
					if (!this.validatenull(tempData.offpayConfig)) {
						Object.assign(tempData.offpayConfig, {
							startTime,
							endTime,
							remind,
							refusePrompt,
						})
					}
					if (!this.validatenull(childConfig) && !this.validatenull(this.currentOptionChildData)) {
						//存在子项目
						let tempChildData = this.deepClone(this.currentOptionChildData)

						for (let tempChildDataKey in tempChildData) {
							if (tempChildDataKey.includes('$') || tempChildDataKey === 'areaConfig') {
								delete tempChildData[tempChildDataKey]
							}
						}
						let {areaConfig = ''} = this.currentOptionChildData

						tempData.childConfig[areaConfig] = tempChildData
					}
					console.log('tempData---', tempData)
					//发送接口数据
					console.log(tempConfigDataAll, '----345')
					tempConfigDataAll.text = JSON.stringify(tempConfigDataAll.text)
					this.isLoading = false
					editConfig(tempConfigDataAll)
						.then((response) => {
							this.configDataAll.text = JSON.parse(tempConfigDataAll.text)
							this.$alert('配置已修改成功，请手动刷新！', '提示')
								.then(() => {})
								.catch(() => {})
						})
						.finally(() => {
							this.isLoading = false
						})
				})
				.catch(() => {})
		},
		onRefreshData() {
			//https://www.meibaokeji.com.cn/employer/index/renew_config
			let tempUrl = `https://www.${process.env.NODE_ENV === 'production' ? '' : 'test.'}meibaokeji.com.cn/employer/index/renew_config`
			window.open(tempUrl, '_blank')
		},
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
}
</script>

<style lang="scss" scoped></style>
